"use client"
import { supabase } from "../../supabaseClient"
import { useAuth } from "../../context/AuthContext"
import { applyInstitutionFilter } from "../../lib/tenant"
import "../../styles/DptList.css"

export default function DptList({ departamentos, refresh, onEdit }) {
  const { isAdmin, instituicaoId } = useAuth()

  const handleDelete = async (dpt) => {
    if (!window.confirm(`Deseja realmente excluir o departamento "${dpt.nome}"?`)) return

    try {
      // Verificar se há cursos usando este departamento
      let cursosQuery = supabase.from("cursos").select("id").eq("departamento_id", dpt.id)
      cursosQuery = applyInstitutionFilter(cursosQuery, isAdmin, instituicaoId)
      const { data: cursosUsando } = await cursosQuery

      if (cursosUsando && cursosUsando.length > 0) {
        const confirmar = window.confirm(
          `Este departamento está associado a ${cursosUsando.length} curso(s). Deseja remover a associação e excluir?`,
        )
        if (!confirmar) return

        // Remover associação com cursos
        await supabase.from("cursos").update({ departamento_id: null }).eq("departamento_id", dpt.id)
      }

      // Verificar se há professores usando este departamento
      let profsQuery = supabase.from("professores").select("id").eq("departamento_id", dpt.id)
      profsQuery = applyInstitutionFilter(profsQuery, isAdmin, instituicaoId)
      const { data: profsUsando } = await profsQuery

      if (profsUsando && profsUsando.length > 0) {
        // Remover associação com professores
        await supabase.from("professores").update({ departamento_id: null }).eq("departamento_id", dpt.id)
      }

      // Deletar departamento
      const { error } = await supabase.from("departamentos").delete().eq("id", dpt.id)

      if (error) throw error

      alert("Departamento excluído com sucesso!")
      refresh()
    } catch (err) {
      console.error("Erro ao deletar departamento:", err.message)
      alert("Erro ao excluir: " + err.message)
    }
  }

  return (
    <div className="dpt-list-container">
      <h3 className="list-title">Departamentos Cadastrados</h3>

      {departamentos.length === 0 ? (
        <div className="empty-state">
          <p>Nenhum departamento cadastrado.</p>
        </div>
      ) : (
        <div className="dpt-list">
          {departamentos.map((dpt) => (
            <div key={dpt.id} className="dpt-card">
              <div className="card-header">
                <h3 className="dpt-nome">{dpt.nome}</h3>
              </div>

              <div className="card-actions">
                <button className="btn-editar" onClick={() => onEdit && onEdit(dpt)}>
                  Editar
                </button>
                <button className="btn-excluir" onClick={() => handleDelete(dpt)}>
                  Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
